import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import { ButtonSize, ButtonVariant } from 'components/UI_kit_3/Button/Button';
import { Link, LinkProps } from 'react-router-dom';
import styles from './Button.module.scss';

export interface IRouterLinkButtonProps extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize
  disabled?: boolean;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
}

const RouterLinkButton = forwardRef<HTMLAnchorElement, IRouterLinkButtonProps>(({
  children,
  variant = 'primary',
  className,
  size = 'md',
  prefixIcon,
  suffixIcon,
  disabled,
  ...props
}, ref) => {
  const variantClass = useMemo<string>(() => styles[`btn-${variant}`], [variant]);
  const sizeClass = useMemo<string>(() => styles[`btn-${size}`], [size]);

  return (
    <Link
      ref={ref}
      className={classNames(className, styles.btn, variantClass, sizeClass, {
        [styles.disabled]: disabled,
      })}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {prefixIcon}
      {children && <span>{children}</span>}
      {suffixIcon}
    </Link>
  );
});
export default RouterLinkButton;
